import { render, staticRenderFns } from "./listComponents.vue?vue&type=template&id=aa80aba0&scoped=true&"
import script from "./listComponents.vue?vue&type=script&lang=js&"
export * from "./listComponents.vue?vue&type=script&lang=js&"
import style0 from "./listComponents.vue?vue&type=style&index=0&id=aa80aba0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa80aba0",
  null
  
)

export default component.exports